import { findConnector } from "./connectorCatalog";
import type { ProjectSelection, Server } from "./api";

// A playbook's requires_tools entry, resolved against the user's connected
// servers and this agent's selection into one of three states:
//   connect  — not connected at all → user must connect it
//   attach   — connected, but not exposed to this agent → one-tap attach
//   attached — connected and exposed to this agent → ✓
export type RecommendedRow =
  | { kind: "connect"; key: string; display: string }
  | { kind: "attach" | "attached"; key: string; display: string; serverName: string };

// recommendedRows is the single source of truth shared by the in-chat
// IntegrationsPanel and the agent's Integrations tab, so both compute identical
// status. selection == null means "all connected are attached".
export function recommendedRows(
  needed: string[],
  servers: Server[],
  selection: ProjectSelection | null,
): RecommendedRow[] {
  return needed.map((name) => {
    const wanted = findConnector(name);
    const server = servers.find(
      (s) =>
        s.connected &&
        (s.name.toLowerCase() === name.toLowerCase() || (wanted !== undefined && findConnector(s.name)?.id === wanted.id)),
    );
    if (!server) return { key: name, display: wanted?.name ?? name, kind: "connect" };
    const attached = selection == null || selection.servers.some((s) => s.name === server.name);
    return { key: name, display: wanted?.name ?? server.name, serverName: server.name, kind: attached ? "attached" : "attach" };
  });
}

// unmetCount is how many recommended integrations are not yet attached — the
// number surfaced as the Integrations-tab badge.
export const unmetCount = (rows: RecommendedRow[]): number => rows.filter((r) => r.kind !== "attached").length;
